import type { ComponentType } from "react";
import type { FallbackProps } from "react-error-boundary";
import { Button } from "../components/ui/Button";

export const ErrorFallback: ComponentType<FallbackProps> = ({
    error,
    resetErrorBoundary,
}: {
    error: Error | unknown;
    resetErrorBoundary: () => void;
}) => {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center px-4 py-12 text-center bg-gray-50">
            <h1 className="text-3xl font-bold mb-2">Something went wrong</h1>
            <p className="text-gray-600 max-w-md mb-6">
                An unexpected error occurred. We've logged the issue and will look into it.
            </p>
            <details className="text-sm text-gray-500 max-w-md mb-6 whitespace-pre-wrap">
                {error instanceof Error ? error.message : String(error)}
            </details>
            <div className="flex gap-4">
                <Button onClick={resetErrorBoundary}>Try again</Button>
            </div>
            {process.env.NODE_ENV === "development" && (
                <details className="text-sm text-gray-500 max-w-md mb-6 whitespace-pre-wrap">{error instanceof Error && error.stack}</details>
            )}
        </div>
    );
}
